// @ts-nocheck
import * as React from "react";
import PropTypes from "prop-types";

import AnchorLink from "../anchorLink";

import styles from "./styles.css";

export default function SubMenu({ subItems }) {
    return (
        <div className={styles.SubMenu}>
            <ul className={styles[`SubMenu-nav`]}>
                {subItems.map(({ label, description, path }) => (
                    <li className={styles[`SubMenu-navItem`]} key={label}>
                        <AnchorLink href={path} className={styles[`SubMenu-navItemLink`]}>
                            {label}
                            {description && <span className={styles.description}>{description}</span>}
                        </AnchorLink>
                    </li>
                ))}
            </ul>
        </div>
    );
}

SubMenu.propTypes = {
    subItems: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            description: PropTypes.string,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
};
